/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserDecksDTO
 */
export interface GetUserDecksDTO {
    /**
     * 
     * @type {string}
     * @memberof GetUserDecksDTO
     */
    userId: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserDecksDTO
     */
    listOnlyEditableDecks?: boolean;
}

/**
 * Check if a given object implements the GetUserDecksDTO interface.
 */
export function instanceOfGetUserDecksDTO(value: object): value is GetUserDecksDTO {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function GetUserDecksDTOFromJSON(json: any): GetUserDecksDTO {
    return GetUserDecksDTOFromJSONTyped(json, false);
}

export function GetUserDecksDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserDecksDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'listOnlyEditableDecks': json['listOnlyEditableDecks'] == null ? undefined : json['listOnlyEditableDecks'],
    };
}

export function GetUserDecksDTOToJSON(json: any): GetUserDecksDTO {
    return GetUserDecksDTOToJSONTyped(json, false);
}

export function GetUserDecksDTOToJSONTyped(value?: GetUserDecksDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'listOnlyEditableDecks': value['listOnlyEditableDecks'],
    };
}

